export const FooterContainer = (logo: string, year: number) => (`
  <div class="footer-container">
    <div style="color: #505066;font-size: 16px;font-style: normal;font-weight: 600;line-height: 24px;margin-bottom: 20px;">
      <img style="display: inline-block;vertical-align: middle;width:22px;" src="${logo}" alt="logo"/>
      <div style="display: inline-block;vertical-align: middle;">Stockhide ${year}</div>
    </div>
    <a clicktracking="off" style="color: #6D6D6D;font-size: 12pxtext-decoration: underline;" href="https://help.stockhide.com/help/how-to-unsubscribe-to-email-notifications" target="_blank">Do not want to receive those emails?</a>
  </div>
`);